import { createContext, useCallback, useMemo, useRef, useState } from "react"

export const SidebarContentContext = createContext(null)

export function SidebarContentProvider({ children, routeSidebarContentGroup }) {
  const [content, setContent] = useState(null)
  const activeSidebarGroupRef = useRef(null)
  const routeSidebarGroupRef = useRef(routeSidebarContentGroup || null)

  routeSidebarGroupRef.current = routeSidebarContentGroup || null

  const setSidebarContent = useCallback((nextContent) => {
    activeSidebarGroupRef.current = routeSidebarGroupRef.current
    setContent(nextContent ?? null)
  }, [])

  const clearSidebarContent = useCallback(() => {
    const activeGroup = activeSidebarGroupRef.current
    const nextRouteGroup = routeSidebarGroupRef.current

    // Preserve current content while the next page in the same group mounts.
    if (activeGroup && nextRouteGroup && activeGroup === nextRouteGroup) {
      return
    }

    activeSidebarGroupRef.current = null
    setContent(null)
  }, [])

  const value = useMemo(
    () => ({
      content,
      setSidebarContent,
      clearSidebarContent,
    }),
    [content, setSidebarContent, clearSidebarContent],
  )

  return (
    <SidebarContentContext.Provider value={value}>
      {children}
    </SidebarContentContext.Provider>
  )
}
